/** @format */

import {CellContext} from '@tanstack/react-table';

import {useTranslation} from 'react-i18next';

import {TanStackTableData, TanStackTableValue} from 'components/Table/core/types';

import {isObjectValueGuard} from 'components/Table/core/helpers/isObjectValueGuard';
import {sensorName} from 'helpers/sensor_names';

import {getValue} from 'components/Table/core/helpers/getValue';

import {SensorDetailed} from '../SensorDetailed';

const FormattedCellSubRow = (info: CellContext<TanStackTableData, TanStackTableValue>) => {
  const {t} = useTranslation();

  const value = info.getValue();

  if (isObjectValueGuard(value)) {
    const name = Object.keys(value)[0];
    const text = t(sensorName(name));
    return <SensorDetailed name={name} text={text} value={value[name]} />;
  }

  return getValue(info);
};

export {FormattedCellSubRow};
